import * as THREE from 'three';
import type { PanelSize } from '@roomtreatment/core';

const _mtx = new THREE.Matrix4();

export function footprintHalfXZ(
  size: PanelSize,
  rot: THREE.Euler,
): { hx: number; hz: number } {
  _mtx.makeRotationFromEuler(rot);
  const e = _mtx.elements;
  const ex = size.w / 2;
  const ey = size.h / 2;
  const ez = size.d / 2;
  return {
    hx: Math.abs(e[0]) * ex + Math.abs(e[4]) * ey + Math.abs(e[8]) * ez,
    hz: Math.abs(e[2]) * ex + Math.abs(e[6]) * ey + Math.abs(e[10]) * ez,
  };
}
